import React from 'react';
import {connect} from 'react-redux';

export function mapStateToProps(state) {
    return {
        heading: state.modules.retryCard.heading,
        text: state.modules.retryCard.text,
        button: state.modules.retryCard.button,
    };
}

export function RetryCardComponent({heading, text, button, onClickHandler}) {
    return (
        <div className="great-places-retry-card">
            <h3>{heading}</h3>
            <p>{text}</p>
            <button className="btn btn-sm btn-default" onClick={onClickHandler}>
                {button}
            </button>
        </div>
    );
}

export const RetryCard = connect(mapStateToProps)(RetryCardComponent);

RetryCard.displayName = 'RetryCard';

export default RetryCard;
